import React from 'react';
import ServicePage from '../components/ServicePage';
import { getServiceData } from '../data/servicesData';
import { getServiceSEO } from '../utils/serviceSEO';

const BanosEstandarPage: React.FC = () => {
  const serviceData = getServiceData('banos-portatiles-estandar');

  if (!serviceData) {
    return <div>Servicio no encontrado</div>;
  }

  const seoData = getServiceSEO('banos-portatiles-estandar', serviceData);

  return (
    <ServicePage
      {...serviceData}
      seoTitle={seoData.title}
      seoDescription={seoData.description}
      seoKeywords={seoData.keywords}
      seoUrl={seoData.url}
      structuredData={seoData.structuredData}
    />
  );
};

export default BanosEstandarPage;